import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const shadow_meld = {
  slug: "shadow_meld",
  name: "Shadow Meld",
  description: "Blend into the shadows",
  abilityIcon: "shadow_meld",
  costs: [
    { stat: "energy", value: 10 }
  ],
  targeting: Targeting.Self,
  cooldown: SEC(6),
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [
            {
              slug: "shadow_meld",
              name: "Shadow Meld",
              tags: ["buff", "stealth"]
            }
          ],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "buff", "black"]
};
export {
  shadow_meld
};
//# sourceMappingURL=data:application/json;base64,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
